<template>
  <div
    v-if="reseted"
    id="rmpPlayer"
    class="video-player"
  />
</template>

<script>
  // export
  export default {
    name: 'VideoPlayer',
    props: {
      start: {
        type: Number,
        default: 0,
      },
      crossOrigin: {
        type: String,
        default: '',
      },
      playsinline: {
        type: Boolean,
        default: false,
      },
      customEventName: {
        type: String,
        default: 'statechanged',
      },
      src: {
        type: String,
        default: '',
      },
      options: {
        type: Object,
        required: true,
      },
      events: {
        type: Array,
        default: () => [],
      },
      globalOptions: {
        type: Object,
        default: () => ({
          // autoplay: false,
          controls: true,
          // preload: 'auto',
          // fluid: false,
          // muted: false,
          controlBar: {
            remainingTimeDisplay: false,
            playToggle: {},
            progressControl: {},
            fullscreenToggle: {},
            volumeMenuButton: {
              inline: false,
              vertical: true,
            },
          },
          techOrder: ['html5'],
          plugins: {},
        }),
      },
      globalEvents: {
        type: Array,
        default: () => [],
      },
      trackList: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        player: null,
        playerSrc: {
          hls: ' ',
        },
        reseted: true,
      }
    },
    watch: {
      src (newVal, oldVal) {
        console.log('newVal', newVal)

        if (newVal) {
          this.initialize()
          this.playerSrc.hls = newVal
         // this.setNewSrc(newVal)
        }
        console.log('oldVal', oldVal)
      },
      options: {
        deep: true,
        handler (options, oldOptions) {
 /*         console.log('options', options)
          console.log('oldOptions', oldOptions)
          this.dispose(() => {
            if (options && options.sources && options.sources.length) {
              this.initialize()
            }
          })*/
        },
      },
    },
    mounted () {
      if (!this.player) {
       // this.initialize()
      }
    },
    beforeDestroy () {
      if (this.player) {
        // this.dispose()
      }
    },
    methods: {
      initialize () {
        const settings = {
          licenseKey: 'amxtbHpteGphbEAxNTYxMTI5',
          src: this.playerSrc,
          isLive: true,
          //isLiveDvr: true,
          detectAutoplayCapabilities: true,
          autoplay: true,
          skin: 's2',
          doubleClickForFullscreen: true,
          contentMetadata: {
            poster: [
              'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb-_sIghzrtOAAFruzrI1jf3_4Zc1g24oIZvstQYDAxmoWPV3j7nAicTzRUlJn-Ph_JX4&usqp=CAU'
            ]
          },
        }

        // emit event
        const emitPlayerState = (event, value) => {
          if (event) {
            this.$emit(event, this.player)
          }
          if (value) {
            this.$emit(this.customEventName, { [event]: value })
          }
        }

        this.player = new RadiantMP('rmpPlayer')
        this.player.init(settings)

        const rmpContainer = document.getElementById('rmpPlayer')

        const self = this
        rmpContainer.addEventListener('warning', function () {
          console.log('warning', self.player)
          if (self.player) {
            const d = self.player.getErrorData()

            emitPlayerState('warning', d.event)

            console.log('warning', d)
            if (d.event && d.event.details === 'bufferStalledError') {
              // setNewLink();
            }
          }
        })

        rmpContainer.addEventListener('ready', function () {
          console.log('ready')
          emitPlayerState('ready', true)
        })
      },
      setNewSrc (sourceURL) {
        const newSourceObject = {
          hls: sourceURL,
        }
        console.log('this.player', this.player.getSrc())
        console.log('setNewSrc', newSourceObject)
        this.player.setSrc(newSourceObject)
        //this.player.src.hls = sourceURL
      },
      dispose (callback) {
        if (this.player && this.player.dispose) {
          if (this.player.techName_ !== 'Flash') {
            this.player.pause && this.player.pause()
          }
          this.player.dispose()
          this.player = null
          this.$nextTick(() => {
            this.reseted = false
            this.$nextTick(() => {
              this.reseted = true
              this.$nextTick(() => {
                callback && callback()
              })
            })
          })
        /*
        if (!this.$el.children.length) {
          const video = document.createElement('video')
          video.className = 'video-js'
          this.$el.appendChild(video)
        }
        */
        }
      },
    },
  }
</script>
